<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="content-chapter1" id="calibre_toc_4"><a href="#/OEBPS/5Ingredient_split_006#_idTextAnchor019">Pantry Staples<span id="_idTextAnchor002"></span> </a></p>
<p class="body_heading"><span class="bold2">Savory Pantry Essentials</span></p>
<p class="body_body">Here are the pantry staples you will need to make the recipes in this cookbook. I think we can all agree that cooking fats, vinegar, salt, pepper, etc. don’t count as one of the five ingredients. It’s really amazing what you can create with these pantry items, a few fresh things, and a store-bought Bobby Approved product. It’s culin<span>ary</span><span> </span><span>magic!</span></p>
<div class="calibre1" id="calibre_pb_36"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_019.vue?7ae7b4c0